<div class="sub-menu">

  <!-- sub-menu / header -->
  <div class="sub-menu__header" *appCustomisation="[MenuAttributes.MenuHeader]">
    <ng-container *ngIf="backRoute; else tplOnlyHeading">
      <div class="back-link" [routerLink]="backRoute">
        <lds-icon name="arrow-left"></lds-icon>
        <h4 class="m-none">{{ heading }}</h4>
      </div>
    </ng-container>
    <ng-template #tplOnlyHeading>
      <h4 class="m-none">{{ heading }}</h4>
    </ng-template>
  </div>

  <!-- sub-menu / content -->
  <div class="sub-menu__content">

    <!-- subnav / sections -->
    <ng-container *ngFor="let section of items">
      <ul class="sub-menu-group">

        <!-- subnav / items -->
        <ng-container *ngFor="let item of section">
          <li class="sub-menu-group__item">
            <a
              class="nav-link"
              [class.nav-link--disabled]="item.disabled"
              [routerLink]="item.disabled ? null : routePrefix | concat: item.link"
              routerLinkActive="nav-link--active"
              [routerLinkActiveOptions]="{ exact: item.exactMatch ?? true }">

              <!-- item / label -->
              <div class="nav-link__label">
                {{ item.label }}
              </div>

              <!-- item / flags -->
              <div class="nav-link__flags">

                <!-- loading spinner -->
                <ng-container *ngIf="item.isLoading">
                  <span class="flag flag--info">
                    <app-inline-spinner size="sm"></app-inline-spinner>
                  </span>
                </ng-container>

                <!-- flag / requirements + violations -->
                <ng-container *ngIf="item.flags && !item.isLoading">
                  <ng-container *ngFor="let flag of item.flags">
                    <span class="flag flag--{{ flag.appearance || 'info' }}">
                      <lds-icon [name]="flag.name" appearance="inherit">
                      </lds-icon>
                    </span>
                  </ng-container>
                </ng-container>

              </div>

            </a>
          </li>
        </ng-container>

      </ul>

    </ng-container>

  </div>

  <!-- Submit button -->
  <div class="sub-menu__footer" *ngIf="showSubmitButton">
    <lds-button 
      appearance="action"
      (onClick)="onSubmit()"
      [isDisabled]="!canSubmit">
      Submit
    </lds-button>
  </div>
</div>
